import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, Typography } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useCreateAndAddExternalUserToTeam, useRetrieveTeam, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { useNumericParams } from "../utils/useNumericParams";
import { DEFAULT_PLAYER_METADATA, OfflinePlayerForm, } from "./OfflinePlayerForm";
var policyNotice = (_jsxs(Typography, { variant: "caption", color: "text.secondary", sx: { display: "block", textAlign: "center", mt: 1 }, children: ["By adding this player, you confirm you are authorized to enter their information. See our", " ", _jsx(Link, { component: RouterLink, to: "/adding-players", target: "_blank", rel: "noopener", children: "Adding Players" }), " ", "policy."] }));
export var CreateExternalUserAndAddToTeamForm = function () {
    var navigate = useNavigate();
    var teamId = useNumericParams().id;
    var _a = useRetrieveTeam({ id: teamId }), useRetrieveTeamIsLoading = _a.isLoading, useRetrieveTeamError = _a.error, team = _a.data;
    var createAndAddExternalUserToTeamMutation = useCreateAndAddExternalUserToTeam({
        teamId: teamId,
        onMutate: function () { },
        onSuccess: function (data) {
            navigate("/players/".concat(data.data.id, "/"));
        },
        onError: function () { },
    });
    if (createAndAddExternalUserToTeamMutation.isLoading ||
        useRetrieveTeamIsLoading) {
        return _jsx(Loading, {});
    }
    if (!team || useRetrieveTeamError) {
        return _jsx(ErrorView, { error: useRetrieveTeamError });
    }
    return (_jsx(OfflinePlayerForm, { title: "Create and Add Player to ".concat(team.name), submitLabel: "Create", showSquadNumber: true, defaultValues: {
            externalUser: { firstName: "", lastName: "" },
            player: DEFAULT_PLAYER_METADATA,
            squadNumber: null,
        }, isError: !!createAndAddExternalUserToTeamMutation.isError, errorMessage: "Failed to create player. Please try again.", footer: policyNotice, onSubmit: function (data) {
            return createAndAddExternalUserToTeamMutation.mutate(data);
        }, onCancel: function () { return navigate(-1); } }));
};
